import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

/*
FIREBASE SETUP INSTRUCTIONS:

1. Create a Firebase Project:
   - Go to https://console.firebase.google.com/
   - Click "Add project" and follow the setup wizard
   - Once created, click on the web icon (</>) to add a web app
   - Copy the firebaseConfig object values into the config below

2. Enable Firestore Database:
   - In Firebase Console, go to "Build" > "Firestore Database"
   - Click "Create database"
   - Choose "Start in production mode" (we'll set rules next)
   - Select a Cloud Firestore location (choose closest to your users)

3. Configure Firestore Security Rules:
   - In Firestore Database, go to the "Rules" tab
   - Replace the default rules with the following:

   rules_version = '2';
   service cloud.firestore {
     match /databases/{database}/documents {
       match /highScores/{document=**} {
         allow read: if true;
         allow write: if request.resource.data.keys().hasAll(['quizId', 'playerName', 'score', 'totalQuestions', 'accuracy', 'timeMs', 'timestamp']) &&
                         request.resource.data.playerName is string &&
                         request.resource.data.playerName.size() > 0 &&
                         request.resource.data.playerName.size() <= 50 &&
                         request.resource.data.score is int &&
                         request.resource.data.score >= 0 &&
                         request.resource.data.totalQuestions is int &&
                         request.resource.data.totalQuestions > 0 &&
                         request.resource.data.accuracy is number &&
                         request.resource.data.accuracy >= 0 &&
                         request.resource.data.accuracy <= 100 &&
                         request.resource.data.timeMs is number &&
                         request.resource.data.timeMs > 0;
       }
     }
   }

   - Click "Publish" to save the rules

4. Create Firestore Indexes:
   - In Firestore Database, go to the "Indexes" tab
   - Click "Create Index"
   - Collection ID: highScores
   - Add the following fields in this exact order:
     * quizId (Ascending)
     * timeMs (Ascending)
     * accuracy (Descending)
   - Query scope: Collection
   - Click "Create"
   
   Note: The index order must match the query order exactly. The query orders by timeMs first (ascending), 
   then by accuracy (descending), so the index must have those fields in that same order.

5. For Cloudflare Pages Deployment:
   - Add the Firebase config values as environment variables in Cloudflare Pages settings
   - Or use this config.ts file directly by replacing the empty strings below with your values
   - The app will work on Cloudflare Pages as long as Firebase SDK is included in the build
*/

const firebaseConfig = {
  apiKey: "AIzaSyB8WGskl-tDX01dSdNxEG2SA4U7x3RsEjE",
  authDomain: "itsec25-ai-project.firebaseapp.com",
  projectId: "itsec25-ai-project",
  storageBucket: "itsec25-ai-project.firebasestorage.app",
  messagingSenderId: "334521351614",
  appId: "G-VQ5FLTS628"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
